import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
type ModalKey = 'terms' | 'privacy' | null;
export function Footer() {
  const [openModal, setOpenModal] = useState<ModalKey>(null);
  const close = () => setOpenModal(null);
  const lastUpdated = 'May 28, 2026';
  return <>
      <footer className="bg-slate-900 border-t border-white/10 py-12 text-center text-white/50 text-sm" data-id="element-57">
        <div className="max-w-6xl mx-auto px-6" data-id="element-58">
          <div className="font-playfair font-bold text-xl tracking-widest text-white/30 mb-6" data-id="element-59">
            SUGAR HACK
          </div>
          <div className="flex flex-wrap justify-center gap-6 mb-8" data-id="element-60">
            <button onClick={() => setOpenModal('terms')} className="hover:text-white transition-colors" data-id="element-61">
              Terms of Service
            </button>
            <button onClick={() => setOpenModal('privacy')} className="hover:text-white transition-colors" data-id="element-62">
              Privacy Policy
            </button>
            <a href="#" className="hover:text-white transition-colors" data-id="element-63">
              Contact Us
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-64">
              Refund Policy
            </a>
          </div>
          <p className="max-w-2xl mx-auto text-xs leading-relaxed mb-6" data-id="element-65">
            Disclaimer: The information provided in this digital product is for
            educational purposes only and is not intended as a substitute for
            advice from your physician or other health care professional. You
            should not use the information in this product for diagnosis or
            treatment of any health problem.
          </p>
          <p data-id="element-66">
            &copy; {new Date().getFullYear()} The Dental Sugar Hack. All rights
            reserved.
          </p>
        </div>
      </footer>

      <LegalModal open={openModal === 'terms'} onClose={close} title="Terms of Service" data-id="element-67">
        <p className="text-xs uppercase tracking-widest text-sky-600 font-semibold" data-id="element-68">
          Last updated: {lastUpdated}
        </p>
        <section data-id="element-69">
          <h3 className="font-playfair font-bold text-slate-900 text-lg mb-2" data-id="element-70">
            1. Acceptance of Terms
          </h3>
          <p data-id="element-71">
            By purchasing or accessing The Dental Sugar Hack digital system, you
            agree to be bound by these Terms of Service. If you do not agree to
            these terms, please do not use our products or services.
          </p>
        </section>
        <section data-id="element-72">
          <h3 className="font-playfair font-bold text-slate-900 text-lg mb-2" data-id="element-73">
            2. Digital Product Access
          </h3>
          <p data-id="element-74">
            Upon successful payment, you will receive instant digital access to
            the Sugar Hack guide and all included bonuses. Your access is
            personal, non-transferable, and licensed solely for your individual
            use. Resale, redistribution, or public sharing of the materials is
            strictly prohibited.
          </p>
        </section>
        <section data-id="element-75">
          <h3 className="font-playfair font-bold text-slate-900 text-lg mb-2" data-id="element-76">
            3. Educational Disclaimer
          </h3>
          <p data-id="element-77">
            The information provided is for educational purposes only and is not
            intended as medical advice. Always consult with a qualified dental
            or medical professional before making changes to your oral care
            routine. We make no guarantees regarding specific outcomes.
          </p>
        </section>
        <section data-id="element-78">
          <h3 className="font-playfair font-bold text-slate-900 text-lg mb-2" data-id="element-79">
            4. Refund Policy
          </h3>
          <p data-id="element-80">
            We offer a 60-day satisfaction guarantee. If you are not satisfied
            with your purchase, contact our support team within 60 days for a
            full refund.
          </p>
        </section>
        <section data-id="element-81">
          <h3 className="font-playfair font-bold text-slate-900 text-lg mb-2" data-id="element-82">
            5. Intellectual Property
          </h3>
          <p data-id="element-83">
            All content, including text, graphics, logos, and digital materials,
            is the exclusive property of The Dental Sugar Hack and is protected
            by copyright and trademark laws.
          </p>
        </section>
        <section data-id="element-84">
          <h3 className="font-playfair font-bold text-slate-900 text-lg mb-2" data-id="element-85">
            6. Limitation of Liability
          </h3>
          <p data-id="element-86">
            To the maximum extent permitted by law, The Dental Sugar Hack shall
            not be liable for any indirect, incidental, or consequential damages
            arising from your use of our digital products.
          </p>
        </section>
        <section data-id="element-87">
          <h3 className="font-playfair font-bold text-slate-900 text-lg mb-2" data-id="element-88">
            7. Changes to Terms
          </h3>
          <p data-id="element-89">
            We reserve the right to modify these terms at any time. Continued
            use of our services after changes constitutes acceptance of the
            updated terms.
          </p>
        </section>
      </LegalModal>

      <LegalModal open={openModal === 'privacy'} onClose={close} title="Privacy Policy" data-id="element-90">
        <p className="text-xs uppercase tracking-widest text-sky-600 font-semibold" data-id="element-91">
          Last updated: {lastUpdated}
        </p>
        <section data-id="element-92">
          <h3 className="font-playfair font-bold text-slate-900 text-lg mb-2" data-id="element-93">
            1. Information We Collect
          </h3>
          <p data-id="element-94">
            We collect information you provide directly to us, including your
            name, email address, and payment details when you purchase our
            digital products. We also collect anonymous usage data to improve
            our service.
          </p>
        </section>
        <section data-id="element-95">
          <h3 className="font-playfair font-bold text-slate-900 text-lg mb-2" data-id="element-96">
            2. How We Use Your Information
          </h3>
          <p data-id="element-97">
            Your information is used to deliver your purchased digital products,
            process transactions, send relevant updates about your order, and
            provide customer support. We never sell your personal data to third
            parties.
          </p>
        </section>
        <section data-id="element-98">
          <h3 className="font-playfair font-bold text-slate-900 text-lg mb-2" data-id="element-99">
            3. Payment Security
          </h3>
          <p data-id="element-100">
            All transactions are processed through PCI-compliant payment
            providers. We do not store your full credit card information on our
            servers.
          </p>
        </section>
        <section data-id="element-101">
          <h3 className="font-playfair font-bold text-slate-900 text-lg mb-2" data-id="element-102">
            4. Cookies & Tracking
          </h3>
          <p data-id="element-103">
            We use cookies and similar technologies to enhance your browsing
            experience, analyze site traffic, and personalize content. You can
            control cookie preferences through your browser settings.
          </p>
        </section>
        <section data-id="element-104">
          <h3 className="font-playfair font-bold text-slate-900 text-lg mb-2" data-id="element-105">
            5. Email Communications
          </h3>
          <p data-id="element-106">
            By purchasing, you consent to receive transactional emails related
            to your order. You may also receive optional educational content,
            which you can unsubscribe from at any time using the link at the
            bottom of any email.
          </p>
        </section>
        <section data-id="element-107">
          <h3 className="font-playfair font-bold text-slate-900 text-lg mb-2" data-id="element-108">
            6. Your Rights
          </h3>
          <p data-id="element-109">
            You have the right to access, correct, or delete your personal
            information. To exercise these rights, contact us at our support
            email. We will respond to verified requests within 30 days.
          </p>
        </section>
        <section data-id="element-110">
          <h3 className="font-playfair font-bold text-slate-900 text-lg mb-2" data-id="element-111">
            7. Data Retention
          </h3>
          <p data-id="element-112">
            We retain your information for as long as necessary to provide our
            services and comply with legal obligations. You may request deletion
            of your account and associated data at any time.
          </p>
        </section>
        <section data-id="element-113">
          <h3 className="font-playfair font-bold text-slate-900 text-lg mb-2" data-id="element-114">
            8. Contact Us
          </h3>
          <p data-id="element-115">
            If you have questions about this Privacy Policy or how we handle
            your data, please reach out through our Contact Us page.
          </p>
        </section>
      </LegalModal>
    </>;
}